"use strict";
import L from "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster.js";
export default L;
